import { createContext, type RefObject } from "react";

/**
 * Composite controls that render a nonmodal popup can keep it inside the
 * active modal's semantic and focus boundary while still positioning it with
 * fixed viewport coordinates.
 */
export const DialogSurfacePortalContext =
  createContext<RefObject<HTMLElement> | null>(null);
